var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H3a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-5M8 4V3a2 2 0 114 0v1M8 4a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M7 12a3.001 3.001 0 00-2.83 2M13 9h3m-3 4h2",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/identification.be567d7a.svg";
export { SvgIdentification as ReactComponent };